import { getEmployeesTaetigkeiten } from '@chancenwerk/master-data-management/users/api/getEmployeesTaetigkeiten.js';
import { getEmployeesWithTaetigkeit } from '@chancenwerk/master-data-management/users/api/getEmployeesWithTaetigkeit.js';

export namespace EmployeeAPI {
  export const getWithTaetigkeit = getEmployeesWithTaetigkeit;
  export const getTaetigkeiten = getEmployeesTaetigkeiten;
}
